import React, { type ReactNode } from 'react'
import { PlaylistsProvider, usePlaylistsContext } from './PlaylistsProvider'

type PlaylistContainerProvider = ({ children }: { children: ReactNode }) => JSX.Element

/** An adapter hook to help transition from the old to new playlist context */
export const usePlaylistContainerContext = (): ReturnType<typeof usePlaylistsContext> => {
  const playlistState = usePlaylistsContext()

  return playlistState
}

/** An adapter provider to help ease the transition to the new playlist */
export const PlaylistContainerProvider: PlaylistContainerProvider = ({ children }) => {
  return <PlaylistsProvider>{children}</PlaylistsProvider>
}
